// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see ContactAccessGrantPermissionEvent
 */
export var ContactAccessGrantPermission = function (_a) {
    var permissionGranted = _a.permissionGranted, entryPoint = _a.entryPoint, accessLevel = _a.accessLevel;
    return ({
        name: "Contact Access GrantPermission",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Access",
            permission_granted: permissionGranted !== undefined && permissionGranted !== null ? permissionGranted.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            access_level: accessLevel !== undefined && accessLevel !== null ? accessLevel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactAccessRequestPermissionEvent
 */
export var ContactAccessRequestPermission = function (_a) {
    var requestSource = _a.requestSource, entryPoint = _a.entryPoint;
    return ({
        name: "Contact Access RequestPermission",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Access",
            request_source: requestSource !== undefined && requestSource !== null ? requestSource.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteFilterRecommendationsEvent
 */
export var ContactInviteFilterRecommendations = function (_a) {
    var entryPoint = _a.entryPoint, initRecommendationsCount = _a.initRecommendationsCount, recommendedOnCashAliasesCount = _a.recommendedOnCashAliasesCount, recommendedEmailAliasesCount = _a.recommendedEmailAliasesCount, filteredRecommendedContactsCount = _a.filteredRecommendedContactsCount, recommendedUnmappedAliasesCount = _a.recommendedUnmappedAliasesCount;
    return ({
        name: "Contact Invite FilterRecommendations",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            init_recommendations_count: initRecommendationsCount !== undefined && initRecommendationsCount !== null ? initRecommendationsCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recommended_on_cash_aliases_count: recommendedOnCashAliasesCount !== undefined && recommendedOnCashAliasesCount !== null ? recommendedOnCashAliasesCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recommended_email_aliases_count: recommendedEmailAliasesCount !== undefined && recommendedEmailAliasesCount !== null ? recommendedEmailAliasesCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            filtered_recommended_contacts_count: filteredRecommendedContactsCount !== undefined && filteredRecommendedContactsCount !== null ? filteredRecommendedContactsCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recommended_unmapped_aliases_count: recommendedUnmappedAliasesCount !== undefined && recommendedUnmappedAliasesCount !== null ? recommendedUnmappedAliasesCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteOpenContactPermissionExplanationEvent
 */
export var ContactInviteOpenContactPermissionExplanation = function (_a) {
    var entryPoint = _a.entryPoint;
    return ({
        name: "Contact Invite OpenContactPermissionExplanation",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteInviteConsentScreenViewedEvent
 */
export var ContactInviteInviteConsentScreenViewed = function (_a) {
    var section = _a.section, areaCodeState = _a.areaCodeState;
    return ({
        name: "Contact Invite InviteConsentScreenViewed",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            section: section !== undefined && section !== null ? section.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            area_code_state: areaCodeState !== undefined && areaCodeState !== null ? areaCodeState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteInviteConsentScreenDismissedEvent
 */
export var ContactInviteInviteConsentScreenDismissed = function (_a) {
    var confirmed = _a.confirmed;
    return ({
        name: "Contact Invite InviteConsentScreenDismissed",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            confirmed: confirmed !== undefined && confirmed !== null ? confirmed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInvitePrefillRequestEvent
 */
export var ContactInvitePrefillRequest = function (_a) {
    var aliasType = _a.aliasType, isRecommended = _a.isRecommended, hashedAliasId = _a.hashedAliasId, entryPoint = _a.entryPoint;
    return ({
        name: "Contact Invite PrefillRequest",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_recommended: isRecommended !== undefined && isRecommended !== null ? isRecommended.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            hashed_alias_id: hashedAliasId !== undefined && hashedAliasId !== null ? hashedAliasId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteRegisterAliasEvent
 */
export var ContactInviteRegisterAlias = function (_a) {
    var aliasType = _a.aliasType, section = _a.section, isRecommended = _a.isRecommended, hashedAliasId = _a.hashedAliasId, entryPoint = _a.entryPoint;
    return ({
        name: "Contact Invite RegisterAlias",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section: section !== undefined && section !== null ? section.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_recommended: isRecommended !== undefined && isRecommended !== null ? isRecommended.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            hashed_alias_id: hashedAliasId !== undefined && hashedAliasId !== null ? hashedAliasId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteCompleteEvent
 */
export var ContactInviteComplete = function (_a) {
    var trigger = _a.trigger, entryPoint = _a.entryPoint;
    return ({
        name: "Contact Invite Complete",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteSentEvent
 */
export var ContactInviteSent = function (_a) {
    var invitationToken = _a.invitationToken, entryPoint = _a.entryPoint, section = _a.section, isRecommended = _a.isRecommended;
    return ({
        name: "Contact Invite Sent",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            invitation_token: invitationToken !== undefined && invitationToken !== null ? invitationToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            section: section !== undefined && section !== null ? section.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_recommended: isRecommended !== undefined && isRecommended !== null ? isRecommended.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteStartEvent
 */
export var ContactInviteStart = function (_a) {
    var entryPoint = _a.entryPoint, permissionGranted = _a.permissionGranted, recommendationsCount = _a.recommendationsCount;
    return ({
        name: "Contact Invite Start",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            permission_granted: permissionGranted !== undefined && permissionGranted !== null ? permissionGranted.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recommendations_count: recommendationsCount !== undefined && recommendationsCount !== null ? recommendationsCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteViewErrorEvent
 */
export var ContactInviteViewError = function () { return ({
    name: "Contact Invite ViewError",
    parameters: {
        cdf_entity: "Contact",
        cdf_action: "Invite",
    }
}); };
/**
 * @see ContactInviteViewInfoEvent
 */
export var ContactInviteViewInfo = function () { return ({
    name: "Contact Invite ViewInfo",
    parameters: {
        cdf_entity: "Contact",
        cdf_action: "Invite",
    }
}); };
/**
 * @see ContactInviteViewInvitationShareSheetEvent
 */
export var ContactInviteViewInvitationShareSheet = function (_a) {
    var source = _a.source;
    return ({
        name: "Contact Invite ViewInvitationShareSheet",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteViewRecommendationsEvent
 */
export var ContactInviteViewRecommendations = function (_a) {
    var entryPoint = _a.entryPoint, allContactsCount = _a.allContactsCount, recommendedHashedAliasId1 = _a.recommendedHashedAliasId1, recommendedHashedAliasId2 = _a.recommendedHashedAliasId2, recommendedHashedAliasId3 = _a.recommendedHashedAliasId3;
    return ({
        name: "Contact Invite ViewRecommendations",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            all_contacts_count: allContactsCount !== undefined && allContactsCount !== null ? allContactsCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recommended_hashed_alias_id_1: recommendedHashedAliasId1 !== undefined && recommendedHashedAliasId1 !== null ? recommendedHashedAliasId1.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recommended_hashed_alias_id_2: recommendedHashedAliasId2 !== undefined && recommendedHashedAliasId2 !== null ? recommendedHashedAliasId2.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recommended_hashed_alias_id_3: recommendedHashedAliasId3 !== undefined && recommendedHashedAliasId3 !== null ? recommendedHashedAliasId3.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteCompleteInvitationShareEvent
 */
export var ContactInviteCompleteInvitationShare = function (_a) {
    var activity = _a.activity, source = _a.source;
    return ({
        name: "Contact Invite CompleteInvitationShare",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Invite",
            activity: activity !== undefined && activity !== null ? activity.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactInviteFromSponsorViewStartEvent
 */
export var ContactInviteFromSponsorViewStart = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "Contact InviteFromSponsorView Start",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "InviteFromSponsorView",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactEncryptedSyncDedupeAddedContactsEvent
 */
export var ContactEncryptedSyncDedupeAddedContacts = function (_a) {
    var previousPatchId = _a.previousPatchId, initialAddedContactsCount = _a.initialAddedContactsCount, dedupedAddedContactsCount = _a.dedupedAddedContactsCount, duplicateContactsCount = _a.duplicateContactsCount;
    return ({
        name: "Contact EncryptedSync DedupeAddedContacts",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "EncryptedSync",
            previous_patch_id: previousPatchId !== undefined && previousPatchId !== null ? previousPatchId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            initial_added_contacts_count: initialAddedContactsCount !== undefined && initialAddedContactsCount !== null ? initialAddedContactsCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            deduped_added_contacts_count: dedupedAddedContactsCount !== undefined && dedupedAddedContactsCount !== null ? dedupedAddedContactsCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duplicate_contacts_count: duplicateContactsCount !== undefined && duplicateContactsCount !== null ? duplicateContactsCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactEncryptedSyncStartEvent
 */
export var ContactEncryptedSyncStart = function (_a) {
    var triggerReason = _a.triggerReason, contactsAdded = _a.contactsAdded, contactsRemoved = _a.contactsRemoved, type = _a.type;
    return ({
        name: "Contact EncryptedSync Start",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "EncryptedSync",
            triggerReason: triggerReason !== undefined && triggerReason !== null ? triggerReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            contactsAdded: contactsAdded !== undefined && contactsAdded !== null ? contactsAdded.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            contactsRemoved: contactsRemoved !== undefined && contactsRemoved !== null ? contactsRemoved.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactEncryptedSyncNetworkErrorEvent
 */
export var ContactEncryptedSyncNetworkError = function (_a) {
    var triggerReason = _a.triggerReason, description = _a.description, type = _a.type;
    return ({
        name: "Contact EncryptedSync NetworkError",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "EncryptedSync",
            triggerReason: triggerReason !== undefined && triggerReason !== null ? triggerReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            description: description !== undefined && description !== null ? description.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactEncryptedSyncClearDataEvent
 */
export var ContactEncryptedSyncClearData = function (_a) {
    var reason = _a.reason;
    return ({
        name: "Contact EncryptedSync ClearData",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "EncryptedSync",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactEncryptedSyncSkipEvent
 */
export var ContactEncryptedSyncSkip = function (_a) {
    var reason = _a.reason, type = _a.type;
    return ({
        name: "Contact EncryptedSync Skip",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "EncryptedSync",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactEncryptedSyncCompleteEvent
 */
export var ContactEncryptedSyncComplete = function (_a) {
    var triggerReason = _a.triggerReason, type = _a.type, result = _a.result, errorDescription = _a.errorDescription, roundtripDuration = _a.roundtripDuration;
    return ({
        name: "Contact EncryptedSync Complete",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "EncryptedSync",
            triggerReason: triggerReason !== undefined && triggerReason !== null ? triggerReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            errorDescription: errorDescription !== undefined && errorDescription !== null ? errorDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            roundtripDuration: roundtripDuration !== undefined && roundtripDuration !== null ? roundtripDuration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncStartEvent
 */
export var ContactSyncStart = function (_a) {
    var triggerReason = _a.triggerReason, contactsAdded = _a.contactsAdded, contactsRemoved = _a.contactsRemoved, type = _a.type;
    return ({
        name: "Contact Sync Start",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            triggerReason: triggerReason !== undefined && triggerReason !== null ? triggerReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            contactsAdded: contactsAdded !== undefined && contactsAdded !== null ? contactsAdded.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            contactsRemoved: contactsRemoved !== undefined && contactsRemoved !== null ? contactsRemoved.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncNetworkErrorEvent
 */
export var ContactSyncNetworkError = function (_a) {
    var triggerReason = _a.triggerReason, description = _a.description, type = _a.type;
    return ({
        name: "Contact Sync NetworkError",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            triggerReason: triggerReason !== undefined && triggerReason !== null ? triggerReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            description: description !== undefined && description !== null ? description.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncClearDataEvent
 */
export var ContactSyncClearData = function (_a) {
    var reason = _a.reason;
    return ({
        name: "Contact Sync ClearData",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncSkipEvent
 */
export var ContactSyncSkip = function (_a) {
    var reason = _a.reason, type = _a.type;
    return ({
        name: "Contact Sync Skip",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncCompleteEvent
 */
export var ContactSyncComplete = function (_a) {
    var triggerReason = _a.triggerReason, type = _a.type, result = _a.result, errorDescription = _a.errorDescription, roundtripDuration = _a.roundtripDuration;
    return ({
        name: "Contact Sync Complete",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            triggerReason: triggerReason !== undefined && triggerReason !== null ? triggerReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            result: result !== undefined && result !== null ? result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            errorDescription: errorDescription !== undefined && errorDescription !== null ? errorDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            roundtripDuration: roundtripDuration !== undefined && roundtripDuration !== null ? roundtripDuration.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncNormalizeEmailAliasEvent
 */
export var ContactSyncNormalizeEmailAlias = function () { return ({
    name: "Contact Sync NormalizeEmailAlias",
    parameters: {
        cdf_entity: "Contact",
        cdf_action: "Sync",
    }
}); };
/**
 * @see ContactSyncForceFreshSyncDisabledEvent
 */
export var ContactSyncForceFreshSyncDisabled = function () { return ({
    name: "Contact Sync ForceFreshSyncDisabled",
    parameters: {
        cdf_entity: "Contact",
        cdf_action: "Sync",
    }
}); };
/**
 * @see ContactSyncForceFreshSyncEnabledEvent
 */
export var ContactSyncForceFreshSyncEnabled = function () { return ({
    name: "Contact Sync ForceFreshSyncEnabled",
    parameters: {
        cdf_entity: "Contact",
        cdf_action: "Sync",
    }
}); };
/**
 * @see ContactSyncCompleteFreshSyncEvent
 */
export var ContactSyncCompleteFreshSync = function (_a) {
    var persistHashedAliasIds = _a.persistHashedAliasIds;
    return ({
        name: "Contact Sync CompleteFreshSync",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            persist_hashed_alias_ids: persistHashedAliasIds !== undefined && persistHashedAliasIds !== null ? persistHashedAliasIds.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncPersistNonCustomersEvent
 */
export var ContactSyncPersistNonCustomers = function (_a) {
    var containsHashedAliasIds = _a.containsHashedAliasIds;
    return ({
        name: "Contact Sync PersistNonCustomers",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            contains_hashed_alias_ids: containsHashedAliasIds !== undefined && containsHashedAliasIds !== null ? containsHashedAliasIds.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncWriteToDatabaseEvent
 *
 * @deprecated No longer used.
 */
export var ContactSyncWriteToDatabase = function (_a) {
    var syncLogicType = _a.syncLogicType, numberOfContacts = _a.numberOfContacts, numberOfAddedAliases = _a.numberOfAddedAliases, numberOfRemovedAliases = _a.numberOfRemovedAliases, durationOfWrite = _a.durationOfWrite;
    return ({
        name: "Contact Sync WriteToDatabase",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            sync_logic_type: syncLogicType !== undefined && syncLogicType !== null ? syncLogicType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            number_of_contacts: numberOfContacts !== undefined && numberOfContacts !== null ? numberOfContacts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            number_of_added_aliases: numberOfAddedAliases !== undefined && numberOfAddedAliases !== null ? numberOfAddedAliases.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            number_of_removed_aliases: numberOfRemovedAliases !== undefined && numberOfRemovedAliases !== null ? numberOfRemovedAliases.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration_of_write: durationOfWrite !== undefined && durationOfWrite !== null ? durationOfWrite.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncReadAddressbookEvent
 *
 * @deprecated No longer used.
 */
export var ContactSyncReadAddressbook = function (_a) {
    var syncLogicType = _a.syncLogicType, numberOfContactsImported = _a.numberOfContactsImported, durationOfImportRequest = _a.durationOfImportRequest;
    return ({
        name: "Contact Sync ReadAddressbook",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            sync_logic_type: syncLogicType !== undefined && syncLogicType !== null ? syncLogicType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            number_of_contacts_imported: numberOfContactsImported !== undefined && numberOfContactsImported !== null ? numberOfContactsImported.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration_of_import_request: durationOfImportRequest !== undefined && durationOfImportRequest !== null ? durationOfImportRequest.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncResetEvent
 */
export var ContactSyncReset = function (_a) {
    var reason = _a.reason, hasPreviousSyncToken = _a.hasPreviousSyncToken, hasPreviousPatchId = _a.hasPreviousPatchId;
    return ({
        name: "Contact Sync Reset",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_previous_sync_token: hasPreviousSyncToken !== undefined && hasPreviousSyncToken !== null ? hasPreviousSyncToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_previous_patch_id: hasPreviousPatchId !== undefined && hasPreviousPatchId !== null ? hasPreviousPatchId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncSendToServerEvent
 */
export var ContactSyncSendToServer = function (_a) {
    var syncLogicType = _a.syncLogicType, wasFreshSync = _a.wasFreshSync, numberOfContactsUploaded = _a.numberOfContactsUploaded, numberOfContactsDeleted = _a.numberOfContactsDeleted, durationOfUpload = _a.durationOfUpload, serverResponse = _a.serverResponse, whichSyncPath = _a.whichSyncPath, errorDescription = _a.errorDescription;
    return ({
        name: "Contact Sync SendToServer",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            sync_logic_type: syncLogicType !== undefined && syncLogicType !== null ? syncLogicType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            was_fresh_sync: wasFreshSync !== undefined && wasFreshSync !== null ? wasFreshSync.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            number_of_contacts_uploaded: numberOfContactsUploaded !== undefined && numberOfContactsUploaded !== null ? numberOfContactsUploaded.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            number_of_contacts_deleted: numberOfContactsDeleted !== undefined && numberOfContactsDeleted !== null ? numberOfContactsDeleted.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            duration_of_upload: durationOfUpload !== undefined && durationOfUpload !== null ? durationOfUpload.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            server_response: serverResponse !== undefined && serverResponse !== null ? serverResponse.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            which_sync_path: whichSyncPath !== undefined && whichSyncPath !== null ? whichSyncPath.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_description: errorDescription !== undefined && errorDescription !== null ? errorDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncEvaluateEnabledDisabledFeatureFlagEvent
 */
export var ContactSyncEvaluateEnabledDisabledFeatureFlag = function (_a) {
    var featureFlagName = _a.featureFlagName, enabled = _a.enabled;
    return ({
        name: "Contact Sync EvaluateEnabledDisabledFeatureFlag",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Sync",
            feature_flag_name: featureFlagName !== undefined && featureFlagName !== null ? featureFlagName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactSyncSkipEmptySyncEvent
 */
export var ContactSyncSkipEmptySync = function () { return ({
    name: "Contact Sync SkipEmptySync",
    parameters: {
        cdf_entity: "Contact",
        cdf_action: "Sync",
    }
}); };
/**
 * @see ContactUpdateAddedEvent
 */
export var ContactUpdateAdded = function (_a) {
    var numberOfContacts = _a.numberOfContacts;
    return ({
        name: "Contact Update Added",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Update",
            numberOfContacts: numberOfContacts !== undefined && numberOfContacts !== null ? numberOfContacts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ContactUpdateRemovedEvent
 */
export var ContactUpdateRemoved = function (_a) {
    var numberOfContacts = _a.numberOfContacts;
    return ({
        name: "Contact Update Removed",
        parameters: {
            cdf_entity: "Contact",
            cdf_action: "Update",
            numberOfContacts: numberOfContacts !== undefined && numberOfContacts !== null ? numberOfContacts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
